import React from "react";
import styles from "./CarComparisonMobileTable.module.scss";
import ChatbotSupport from "@components/molecules/ChatbotSupport";
import CarComparisonTable from "../CarComparisonTable";

export default function CarComparisonMobileTable({
  selectedCars,
  config,
  showCompareCTA = false,
  handleEditCar,
  maxMobile = 2,
  maxSpecs,
  brandName,
  modelName,
  cityName,
  carAvailability,
  pageType,
}: any) {
  return (
    <div className={styles.mobileLayout}>
      <CarComparisonTable
        cars={selectedCars}
        showCompareCTA={showCompareCTA}
        showDesktopCompareCTA={false}
        showMobileCompareCTA={true}
        handleEditCar={handleEditCar}
        maxColumns={maxMobile}
        maxSpecs={maxSpecs}
        imageWidth={115}
        imageHeight={60}
        brandName={brandName}
        modelName={modelName}
        cityName={cityName}
        carAvailability={carAvailability}
        pageType={pageType}
        isMobile={true}
      />

      {config.showSideBlock && config.sideBlock && (
        <ChatbotSupport
          heading={config.sideBlock.heading}
          subheading={config.sideBlock.subheading}
          buttonText={config.sideBlock.buttonText}
          buttonLink={config.sideBlock.buttonLink}
          icon={config.sideBlock.icon}
          customChatbotStyling={config.sideBlock.customChatbotStyling}
          chatBotPrompt={config.sideBlock.chatBotPrompt}
          brandName={brandName}
          modelName={modelName}
          cityName={cityName}
          carAvailability={carAvailability}
          pageType={pageType}
          section="Comparison"
        />
      )}
    </div>
  );
}
